// Card component

import React from 'react';

const Card = ({
  children,
  className = '',
  padding = 'normal',
  hover = true,
  onClick,
}) => {
  const paddingSizes = {
    none: '',
    small: 'p-3',
    normal: 'p-4',
    large: 'p-6',
  };

  return (
    <div
      onClick={onClick}
      className={`
        bg-white rounded-xl shadow-card
        ${hover ? 'transition-shadow duration-300 hover:shadow-card-hover' : ''}
        ${onClick ? 'cursor-pointer' : ''}
        ${paddingSizes[padding] || paddingSizes.normal}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '' }) => (
  <div className={`mb-4 ${className}`}>
    {children}
  </div>
);

export const CardTitle = ({ children, className = '' }) => (
  <h3 className={`text-lg font-semibold text-dark-900 ${className}`}>
    {children}
  </h3>
);

export const CardDescription = ({ children, className = '' }) => (
  <p className={`text-sm text-dark-500 mt-1 ${className}`}>
    {children}
  </p>
);

export const CardContent = ({ children, className = '' }) => (
  <div className={className}>
    {children}
  </div>
);

export const CardFooter = ({ children, className = '' }) => (
  <div className={`mt-4 pt-4 border-t border-dark-100 ${className}`}>
    {children}
  </div>
);

export default Card;
